import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import ProgressBar from 'react-bootstrap/ProgressBar';
import EnrollmentStep1 from './EnrollmentStep1';
import EnrollmentStep2 from './EnrollmentStep2';
import EnrollmentStep3 from './EnrollmentStep3';
import EnrollmentStep4 from './EnrollmentStep4';
import EnrollmentStep5 from './EnrollmentStep5';
import EnrollmentSuccess from './EnrollmentSuccess';
import { decode } from 'js-base64';
import { toast } from 'react-toastify';
import { clearForm, setFormData, setStep } from '@app/store/reducers/enrollmentForm';
import { getLeadDetailsBystudent, updateEnrollmentDetailsBystudent } from '@app/services/lead';

const steps = [
	{ id: 0, title: 'Student Details', description: 'Basic details about the student' },
	{ id: 1, title: 'Parent Details', description: 'Parent /Guardian contact details' },
	{ id: 2, title: 'Medical & Emergency', description: 'Medical and emergency contact' },
	{ id: 3, title: 'Media Consent', description: 'Student Photography/Video Consent' },
	{ id: 4, title: 'Terms & Conditions', description: 'Terms & conditions for parents' },
];

const EnrollmentForm = () => {

    const enrollmentStore = useSelector((state: any) => state.enrollmentForm);
	const [isLoading, setLoading] = useState(false);
	const dispatch = useDispatch();
	let { lead_student_id } = useParams()
	const navigate = useNavigate();

	useEffect(() => {
		getLeadDetailsById(decode(lead_student_id))
		if(enrollmentStore?.formData?.status == 'submitted' && enrollmentStore?.formData?.step <= 5){
			toast.warning('Our records indicate that this form has already been submitted.');
			navigate('/')
		}
		return () => {
			dispatch(clearForm())
		}
	},[]);
	
	const getLeadDetailsById = async (lead_student_id) => {           
		try {
			setLoading(true);
			const resp = await getLeadDetailsBystudent(lead_student_id);
			if (resp?.success === true) {
				setLoading(false);
				if(resp?.status == 'submitted' && resp?.step <= 5){
					toast.warning('Our records indicate that this form has already been submitted.')
					navigate('/')
				}
				dispatch(setFormData(resp?.collections))
				dispatch(setStep(resp?.collections?.step || 0));
			} else {
				setLoading(false);
				toast.error(resp?.message || 'Something went wrong');
				navigate('/')
			}
		} catch (error: any) {
			setLoading(false);
			toast.error(error.message);
		}
	};

	const updateEnrollmentDetailsAPI = async (payload) => {
		try {
			setLoading(true);
			const resp = await updateEnrollmentDetailsBystudent(enrollmentStore?.formData?.lead_inquiry_student_id, payload);
			if (resp.success === true) {
				dispatch(setFormData(resp?.collections))
				if(enrollmentStore?.step < 5){
					dispatch(setStep(enrollmentStore?.step + 1));
				}
				setLoading(false);
				toast.success(resp?.message);
			} else {
				toast.error(resp?.errors[0]?.msg);
				setLoading(false);
			}
		} catch (error: any) {
			setLoading(false);
			toast.error(error?.message || 'Something went wrong');
		}
	};

	const renderStep = () => {
		switch (enrollmentStore?.step) {
			case 0:
				return <EnrollmentStep1 updateEnrollmentDetailsAPI={updateEnrollmentDetailsAPI} />;
			case 1:
				return <EnrollmentStep2 updateEnrollmentDetailsAPI={updateEnrollmentDetailsAPI} />;
			case 2:
				return <EnrollmentStep3 updateEnrollmentDetailsAPI={updateEnrollmentDetailsAPI} />;
			case 3:
				return <EnrollmentStep4 updateEnrollmentDetailsAPI={updateEnrollmentDetailsAPI} />;
			case 4:
				return <EnrollmentStep5 updateEnrollmentDetailsAPI={updateEnrollmentDetailsAPI} />;
			case 5:
				return <EnrollmentSuccess />;
			default:
				return null;
		}
	};

	const getStepIcon = (stepNumber: number) => {
		if (stepNumber < enrollmentStore?.step) {
			return <i className="fas fa-check-circle" />;
		} else if (stepNumber === enrollmentStore?.step) {
			return <i className="fas fa-circle"/>;
		} else {
			return <i className="far fa-circle"/>;
		}
	};

	const progressPercentage = ((enrollmentStore?.step) / (steps.length)) * 100;

	return (
		<>
			<section className="modul_sec_wrapper">
			<div className="enrolment-form">
				<div className='content_inner_wrap'>
					<div className="row">
						<div className="col-md-10 mx-auto">
							<img src="/img/banner.jpg" alt="" className="banner-img mb-3"/>
						</div>
						<div className="mx-auto col-md-10 col-lg-10 col-xl-10 text-center">
							<div className="content py-2 mb-3">
								<div>
									<span style={{fontSize: '1.5rem', fontWeight: 'bold'}}>First Class Learning Student Enrolment form</span>
								</div>
								<span className='text-muted'>Complete your application in just a few steps</span>
							</div>
						</div>
						<div className="mx-auto col-md-10 col-lg-10 col-xl-10">
							<div className="content mb-3">
								<div className='pb-4'>
									<div className='d-flex justify-content-between'>
										{ enrollmentStore?.step < 5 ? (
											<span>Step {enrollmentStore?.step + 1} of {steps.length}</span>
										) : (
											<span></span>
										)}
										<span>{progressPercentage}% Completed</span>
									</div>
									<ProgressBar striped variant="success" now={progressPercentage}/>
								</div>
								<div className='row d-flex justify-content-between text-center'>
									{steps.map((step, index) => (
										<div key={index} className='col-md-2'>
											{ getStepIcon(step.id) }
											{/* <i className="fas fa-check-circle" /> */}
											<h6>{step.title}</h6>
											<small className='text-muted'>{step.description}</small>
										</div>
									))}
								</div>
							</div>
						</div>
						<div className="mx-auto col-md-10 col-lg-10 col-xl-10">
							{/* <div className="content mb-3"> */}
								{ renderStep() }
							{/* </div> */}
						</div>
					</div>
				</div>
			</div>	
			</section>
		</>
	);
};

export default EnrollmentForm;